export class User {
  id: string;
  loginAccount: string;
  userName: string;
  email: string;
  userType: string;

  constructor() {
    this.id = '';
    this.loginAccount = '';
    this.userName = '';
    this.email = '';
    this.userType = '';
  }
}
